import {trim} from 'lodash/string'
import api from './index'

export function addTags({userId, uuid, tags}) {

  if(typeof tags === 'string') {
    tags = stringToTags(tags)
  }

  tags = tags.map(tag => trim(tag))

  return api('patch', `resources/${uuid}/user_tags`, {
    user_reference: userId,
    tags
  })
}

function stringToTags(tags) {
  return trim(tags).replace(';',',').split(',')
}



// WEBPACK FOOTER //
// ./webapp/api/tags.js